import diplom1 from '../image/IMG_9501.png';
import diplom2 from '../image/IMG_9502.png';
import diplom3 from '../image/IMG_9504.png';
import diplom4 from '../image/IMG_9505.png';
import diplom5 from '../image/IMG_9506.png';
import diplom6 from '../image/diplom.png';

export const DiplomData = [
    {
        img: diplom1,
        title: 'Диплом "Педагог-психолог"'
    },
    {
        img: diplom2,
        title: 'Диплом "Клинический психолог"'
    },
    {
        img: diplom3,
        title: 'Сертификат "Психодиагностика (по методикам Л.Н.Собчик)"'
    },
    {
        img: diplom4,
        title: 'Психотеропия тревожно-депрессивных и панических расстройств'
    },
    {
        img: diplom5,
        title: 'Психотерапия посттравматических стрессовых растройств'
    },
    {
        img: diplom6,
        title: 'Сертификат участия в практическом курсе "Психология травмы"'
    },
    {
        img: '',
        title: 'Индивидуальные расстановки с использованием фигур'
    }
];